import { HttpBadRequest } from '@httpx/exception'
import type { GetStaticProps, InferGetStaticPropsType } from 'next'
import { ListPage } from '@/features/list/pages'

type Props = {
  /** Add HomeRoute props here */
}

export default function MainRoute(_props: InferGetStaticPropsType<typeof getStaticProps>) {
  return <ListPage />
}

export const getStaticProps: GetStaticProps<Props> = async context => {
  const { locale } = context
  if (locale === undefined) {
    throw new HttpBadRequest('locale is missing')
  }
  return {
    props: {},
  }
}
